export default "__VITE_ASSET__CGOeiS90__"